export default function (location) {
    const search = location.search.slice(1);
    const pairs = search.split('&');
    const obj = {};
    for (let i = 0; i < pairs.length; i += 1) {
        const pair = pairs[i].split('=');
        obj[decodeURI(pair[0])] = pair[1];
    }
    return obj;
}
